<div class="row justify-between card-header px-6 py-3">
    <div class=" text-lg font-medium tracking-tight leading-6 truncate">
        Well Integrity Remarks
    </div>

    <button matTooltip="Image Attachments" (click)="view($event, 0)" *ngIf="data?.attachments?.length > 0">
        <mat-icon style="color: white;">attach_file</mat-icon>
    </button>
</div>

<div class="p-6 container">
    <div class="scroll-box" [innerHTML]="data?.remark"></div>
</div>